<template>
  <div
    class="relative overflow-hidden p-2.5"
    @click.stop="
      $router.push({
        name: 'galGameDetail',
        params: { uuid: game.uuid },
      })
    "
  >
    <div
      class="h-[54px] flex items-center justify-between w-full overflow-hidden rounded-b-lg"
    >
      <div class="flex-1 mr-1">
        <h1 class="text-base font-bold line-clamp-1">
          {{ game.name }}
        </h1>
        <p v-if="showAuthor" class="line-clamp-1">
          {{ $t("game.producer") }}： {{ game.mate?.name }}
        </p>
      </div>
      <button class="btn btn-primary btn-sm px-4">
        {{ $t(`Buttons.view`) }}
      </button>
    </div>

    <div class="text-sm line-clamp-3 my-1">
      {{ game.description }}
    </div>

    <div
      class="relative border rounded-tl rounded-tr overflow-hidden border-b-0"
    >
      <BaseImg :media="game.coverMedia" ratio="16/9" />
      <div
        class="absolute bottom-2.5 left-2.5 bg-[rgba(26,26,26,0.8)] px-2.5 py-1 rounded text-my-gray"
      >
        {{ $t(`game.type.${game.type}`) }}
      </div>
    </div>

    <ul
      class="flex justify-evenly py-2 border rounded-bl rounded-br bg-base-200"
    >
      <li
        v-for="(item, index) in list"
        :key="index"
        class="flex flex-col items-center"
      >
        <h3>
          {{
            item === "character"
              ? game.characterCount! - 1
              : game[(item + "Count") as keyof typeof game]
          }}
        </h3>
        <div class="flex items-center gap-1">
          <i :class="['iconfont  text-sm', 'icon-' + item]"></i>
          {{ $t(`game.static.${item}`) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from "vue";

defineProps({
  game: {
    type: Object as PropType<GalGame>,
    required: true,
  },
  clickAllToPlay: {
    type: Boolean,
    default: false,
  },
  showDesc: {
    type: Boolean,
    default: false,
  },
  showAuthor: {
    type: Boolean,
    default: true,
  },
});

type Static = "end" | "character" | "image" | "audio" | "word";

const list: Static[] = ["end", "character", "image", "audio", "word"];
</script>
